// src/reducers/examsReducer.js
import {
  GET_EXAMS_BY_ORDER_REQUEST,
  GET_EXAMS_BY_ORDER_SUCCESS,
  GET_EXAMS_BY_ORDER_FAILURE,
  SET_EXAMS_BY_ORDER,
  FETCH_PATIENTS,
  SET_FILTER_RANGE,
  SET_LAST_FILTERED_PATIENTS
} from '../actions/exams';

const initialState = {
  loading: false,
  exams: [],
  error: null,
  examsByOrder: {},
  filterOrders: [],
  filterRange: {
    startDate: null,
    endDate: null,
    text: null
  },
  lastFilteredPatients:[]
};

export default function examsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_EXAMS_BY_ORDER_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_EXAMS_BY_ORDER_SUCCESS:
      return { ...state, loading: false, exams: action.payload };
    case GET_EXAMS_BY_ORDER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_EXAMS_BY_ORDER:
      return {
        ...state,
        examsByOrder: {
          ...state.examsByOrder,
          [action.payload.orderNumber]: {
            exams: action.payload.exams,
            isOrderSpecial: action.payload.isOrderSpecial,
          }
          //[action.payload.orderNumber]:action.payload.exams,
        },
      };
    case FETCH_PATIENTS:
      return {
        ...state,
        loading:false,
        filterOrders: action.payload
      };
    case SET_FILTER_RANGE:
      return {
        ...state,
        loading:false,
        filterRange: action.payload
      }
    case SET_LAST_FILTERED_PATIENTS:
      const newPatients = action.payload.filter(
        (newPatient) => !state.lastFilteredPatients.some(
          (existingPatient) => existingPatient.cedula === newPatient.cedula
        )
      );

      return {
        ...state,
        loading:false,
        lastFilteredPatients: [
          ...state.lastFilteredPatients,
          ...newPatients,
        ],
      };

    default:
      return state;
  }
}
